module.exports = __webpack_public_path__ + "static/img/orange.15888aca.png";